<template>
    <div id="Gaiptal">
        <div id="icerik">
            <div id="logo">
                <img src="https://static.supsis.live/common/image/betnanoLogo.svg" />
            </div>

            <div id="banner">
                <div class="header-content">
                    <div class="header-text-one">Taleplerinizi mail yoluyla ya da site içi mesaj aracılığıyla dönüş
                        sağlanmaktadır. Bu sebeple kullanıcı adınızı ve mail adresinizi doğru şekilde iletmenizi rica
                        ederiz.
                    </div>
                    <div class="header-text-two">
                        Betnano S.O.S 24 saat hizmet vermektedir.
                    </div>
                    <div class="header-text-three">
                        HESAP <br> AKTİVASYONU
                    </div>
                </div>
            </div>
            <div style="margin-top: -30px;" class="content">
                <div class="container-header">
                    <img src="../assets/bgTop.png">
                </div>
                <div id="sari-kutu">
                    <iframe
                        :src="`https://form.supsis.ai/form/66dac137a79427e30ac7f853/6423065cd13386cb77688696?username=${username}&fullName=${fullName}&special=true`"
                        width="350px" height="620px" style="border: 0px;" id="myIframe"></iframe>
                    <div class="social-media-icon">
                        <div class="left-align" @click="$router.push({ path: '/betnanoLogin' })">
                            <img src="../assets/rightMenu.svg">
                        </div>
                        <div class="center-align">
                            <div>
                                <a href=" https://t.me/Nano_news_turkiye" target="_blank">
                                    <img src="../assets/telegramIcon.svg">
                                </a>
                            </div>
                            <div>
                                <a href="https://x.com/BNanoHaber" target="_blank">
                                    <img src="../assets/twitIcon.svg">
                                </a>
                            </div>
                            <div>
                                <a href="https://www.youtube.com/@NanoNewsTR" target="_blank">
                                    <img src="../assets/youtubeIcon.svg">
                                </a>
                            </div>
                            <div>
                                <a href="https://www.instagram.com/nanonewsturkiye/" target="_blank">
                                    <img src="../assets/instagramIcon.svg">
                                </a>
                            </div>
                            <div>
                                <a href="https://whatsapp.com/channel/0029VbBaCntICVfsp9TNWS40" target="_blank">
                                    <img src="../assets/whatsappIcon.svg">
                                </a>
                            </div>
                        </div>
                        <div class="right-align" @click="goBack">
                            <img src="../assets/leftMenu.svg">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "GaiptalEtme",
    data() {
        return {
            username: "",
            fullName: "",
        };
    },
    mounted() {
        this.username = this.$route.query.username;
        this.fullName = this.$route.query.fullName;
    },
    methods: {
        goBack() {
            this.$router.go(-1);
        },
    },
};
</script>

<style lang="scss" scoped>
html, body {
    margin: 0;
    padding: 0;
    overflow-x: hidden;
}

#Gaiptal {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    display: flex;
    background: radial-gradient(circle at center top, #C8A244 10%, black 70%);
}


#icerik {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
}

#logo {
    width: 100%;
    text-align: center;
    margin-top: 0;
    background-color: transparent;
    color: white;
    font-size: 24px;

    img {
        width: 300px;
    }
}

#banner {
    width: 100%;
    height: 200px;
    margin: 20px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-size: 20px;

    .header-content {
        width: 100%;
        max-width: 500px;
        height: 200px;
        background-image: url("../assets/header.svg");
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;

        /* Modern Header Text Styles */
        .header-text-one {
            color: #ffffff;
            font-weight: 600;
            font-size: clamp(10px, 2.5vw, 12px);
            max-width: 320px;
            text-align: center;
            margin: auto;
            margin-bottom: 0.5rem;
            line-height: 1.4;
            padding: 0.5rem;
        }

        .header-text-two {
            font-weight: 700;
            color: #fdbc14;
            font-size: clamp(13px, 3vw, 15px);
            text-align: center;
            width: 177px;
            margin: auto;
            margin-bottom: 0.5rem;
        }

        .header-text-three {
            font-weight: 800;
            font-family: -apple-system, BlinkMacSystemFont, sans-serif;
            color: black;
            font-size: clamp(16px, 4vw, 19px);
            text-align: center;
            line-height: 1.2;
            text-shadow: 0 1px 2px rgba(255, 255, 255, 0.3);
        }
    }
}


.container-wrapper {
    max-width: 500px;
    margin: 0 auto;
}

.container-header {
    border-right: 15px solid #ffd905;
}

.container-header, #sari-kutu {
    max-width: 500px;
}

.container-header img {
    width: 100%;
}

#sari-kutu {
    position: relative;
    background: linear-gradient(92deg, #ffda03, #fcb814);
    margin-top: -7px;
    color: black;
    text-align: center;
    font-size: 18px;
    min-height: 100px;
    margin-bottom: 100px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    border-right: 15px solid #ffd905;

    .social-media-icon {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        margin-top: -100px;

        div {
            img {
                width: 30px;
                height: 30px;
                cursor: pointer;
            }
        }
    }

    .left-align {
        flex: 1;
        text-align: left;
        margin-top: -50px;

        img {
            width: 100px !important;
            height: 200px !important;
        }
    }

    .right-align {
        flex: 1;
        text-align: right;
        margin-top: -50px;
        margin-right: -15px;

        img {
            width: 100px !important;
            height: 200px !important;
        }
    }

    .center-align {
        display: flex;
        justify-content: center;
        flex: 2;
    }
}

@media (max-width: 1000px) {
    #Gaiptal {
        display: flex !important;
        flex-direction: column;
        background: radial-gradient(circle at center top, #C8A244 10%, black 30%);
    }
    #banner {
        margin-top: -40px !important;
    }
    .header-content {
        margin-top: 95px;
        height: 150px !important;

        .header-text-one {
            font-size: 10px !important;
        }

        .header-text-three {
            font-size: 16px !important;
            padding: 0px !important;
        }
    }
    .content {
        margin-top: -15px !important;
        margin-right: 10px;
        margin-left: 10px;

    }

}
</style>

